<template>
  <div class="person-container">
    <search class="con"></search>
    <div class="info-container">
      <div class="info con">
        <div class="left_nav">
          <div class="img-box">
            <img v-lazy="userInfo.avatar" alt="" />
          </div>
          <div class="name">{{userInfo.nickname}}</div>
          <div class="tab">
            <ul>
              <!-- <li class="tab-order-center c-pointer" @click="selectTab(-1)">
                订单中心
              </li> -->
              <li>
                <ul class="tab-list">
                  <li
                    :class="index == selectIndex ? 'active' : ''"
                    v-for="(item, index) in tabList"
                    @click="selectTab(index, item)"
                  >
                    {{ item.title }}
                  </li>
                </ul>
              </li>
              <li class="check-download">
                <img
                  :src="require('@/assets/images/icon_chart.png')"
                  alt=""
                  class="c-pointer"
                  @click="selectTab(4)"
                />
              </li>
            </ul>
          </div>
        </div>
        <div class="right-info">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import search from "@/components/search.vue";
import {mapState,mapMutations} from 'vuex'
export default {
  components: { search },
  data() {
    return {
      tabList: [
        // { title: "我的订单" ,url:'myorder'},
        // { title: "售后中心" ,url:'servicecenter'},
        // { title: "我的优惠券",url:'coupon' },
        { title: "我的收藏" ,url:'collect'},
      ],
      selectIndex: -1,
    };
  },
  computed:{
     ...mapState(['hasLogin','userInfo'])
  },
   watch: {
    $route: {
      handler: function (t, f) {
          if (t.name == "myorder") {
            this.selectIndex = 0;
          } else if (t.name == "servicecenter" || t.name == "servicedetail") {
            this.selectIndex = 1;
          } else if (t.name == "coupon") {
            this.selectIndex = 2;
          } else if (t.name == "collect") {
            this.selectIndex = 3;
          } else{
            this.selectIndex = -1;
          }
      },
      immediate: true,
    },
  },
  created(){
    let route = this.$route.name;
    for(let i in this.tabList){
      if(route==this.tabList[i].url) this.selectIndex = i; 
    }
    if(route=='orderdetail') this.selectIndex = 0;
    if(route=='servicedetail') this.selectIndex = 1;
    //console.log('cart')
  },
  methods: {
    selectTab(index, item) {
      //console.log(index)
      this.selectIndex = index;
      if(index!=-1 && index!=4){
        if (this.$route.name!=item.url) this.$router.push({name:item.url})
      }else if(index==-1){
        if (this.$route.name!='center') this.$router.push({name:'center'})
      }else if(index==4){
        if (this.$route.name!='check') this.$router.push({name:'check'})
      }
    },
  },

};
</script>
<style lang="scss" scoped>

.info-container {
  overflow: hidden;
  // min-height: 200px;
  background: #fafafa;
  min-height: calc(100vh - 252px);
  padding-bottom: 30px;
  .info {
    padding-top: 20px;
  }
  .left_nav {
    float: left;
    overflow: hidden;
    border-radius: 4px;
    width: 194px;
    height: 564px;
    background: #ffffff;
    .img-box {
      margin-top: 50px;
      margin-bottom: 18px;
      text-align: center;
      img {
        width: 80px;
        height: 80px;
        border-radius: 50%;
      }
    }
    .name {
      line-height: 22px;
      padding: 0 12px;
      font-size: 16px;
      color: #505050;
      text-align: center;
      margin-bottom: 50px;
    }
  }
}
.tab {
  .tab-order-center {
    font-size: 18px;
    font-weight: 600;
    color: #333333;
    margin-bottom: 18px;
    padding-left: 40px;
  }
  .tab-list {
    line-height: 36px;
    font-size: 14px;
    color: #505050;
    margin-bottom: 20px;
    li {
      cursor: pointer;
      padding-left: 40px;
      position: relative;
    }
    .active {
      color: #f43737;
      &::before {
        content: "";
        left: 0;
        @include abs-y-c;
        background: #f43737;
        width: 3px;
        height: 12px;
      }
    }
  }

}
  .right-info{
    float: right;
    width:calc(100% - 214px);
  }
</style>


// WEBPACK FOOTER //
// src/pages/person/index.vue